import React from 'react';
import PageShell from './PageShell';
import { heroImage } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const IdentitaPage = () => {
  const { t } = useLang();
  const blocks = t('identita.blocks');
  return (
    <PageShell eyebrow={t('identita.eyebrow')} title={t('identita.title')} image={heroImage}>
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 space-y-16">
          {blocks.map((b, i) => (
            <div key={b.title} className="grid md:grid-cols-[140px_1fr] gap-8 items-start">
              <div
                className="text-6xl font-semibold text-[#c53114]/30"
                style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}
              >
                {String(i + 1).padStart(2, '0')}
              </div>
              <div>
                <h3
                  className="text-3xl font-semibold text-[#0b2545]"
                  style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}
                >
                  {b.title.toUpperCase()}
                </h3>
                <p className="mt-4 text-[#475569] leading-relaxed">{b.body}</p>
                {b.quote && (
                  <blockquote className="mt-6 pl-5 border-l-2 border-[#c53114] italic text-[#0b2545] leading-relaxed">
                    {b.quote}
                  </blockquote>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </PageShell>
  );
};

export default IdentitaPage;
